import { useEffect, useState } from "react";
import axios from "axios";

const API = "/api";
const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

const DEFAULT_HSL = "24 100% 50%";

/**
 * Lê primary_color do tenant (formato "H S% L%") via /api/company/settings.
 * Fallback laranja padrão se a chamada falhar ou vier vazio. Não bloqueia
 * a UI — usar valor default enquanto carrega.
 */
export function useTenantPrimaryColor() {
  const [primaryHSL, setPrimaryHSL] = useState(DEFAULT_HSL);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/company/settings`, auth())
      .then((res) => {
        if (cancelled) return;
        const color = (res.data?.primary_color || "").trim();
        if (color) setPrimaryHSL(color);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return primaryHSL;
}
